module.exports = __webpack_public_path__ + "static/media/staffSubImg2.79457ba7.png";